module.exports = __webpack_public_path__ + "static/media/Credit_Risk.0f3e47d1.svg";